// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import HelloSign from 'hellosign-embedded';

// Create the HelloSign Embedded instance.
// Only do this once!

let STAGING_QANDID_CLIENT_ID = '75157d2ef3a1d8729b898ff72ccc256f'
let QANDID_CLIENT_ID = '37bff4c8e845f2eda5ec3d76d0fb9898'
let TRADELINE_STORE_CLIENT_ID = 'd19ee84320e885a741b9fc8800579b1f'
let TURBOTUNING_AI_CLIENT_ID = 'ed30bff705e5d8c0088ab669a32bbd1b'

let DOMAIN_LOCALHOST = 'localhost'
let DOMAIN_QANDID = 'qandid.com'
let DOMAIN_TRADELINE_STORE = 'tradeline.store'
let DOMAIN_STAGING_QANDID = 'staging.qandid.com'
let DOMAIN_TURBOTUNING_AI = 'www.turboturing.ai'

document.addEventListener('DOMContentLoaded', () => {
    let elem_hellosign_client_id = document.getElementById('hellosign_client_id')
    let elem_hellosign_domain = document.getElementById('hellosign_domain')

    let user = undefined
    let local = new RegExp(DOMAIN_LOCALHOST);
    let staging = new RegExp(DOMAIN_STAGING_QANDID);
    let live = new RegExp(DOMAIN_QANDID);
    let tradeline = new RegExp(DOMAIN_TRADELINE_STORE);
    let tuning = new RegExp(DOMAIN_TURBOTUNING_AI);

    // QAN-813: AN EXPLICIT CLIENT ID FROM THE PAGE WINS, always.
    //
    // Everything below it guesses the app from the hostname, and the guess is only ever
    // right while a signer opens a document on the very host it was created on. The
    // partner's invitation points at the store's own domain by design, so a document
    // created under the `qandid` app was opened on tradeline.store, where this guess says
    // `tradeline.store`, and Dropbox Sign refused it — each API app whitelists exactly one
    // domain, so no guess could have been right there.
    //
    // The server knows which app the document belongs to and now renders it into the page
    // (see get_hello_sign_key). The hostname guess is kept only for pages that render no
    // id at all; it is a fallback, no longer the first answer.
    let explicit = elem_hellosign_client_id && elem_hellosign_client_id.value.trim()

    if (explicit) {
        user = explicit
    } else if (local.test(window.location.href) || staging.test(window.location.href)) {
        user = STAGING_QANDID_CLIENT_ID
    } else if (live.test(window.location.href)) {
        user = QANDID_CLIENT_ID
    } else if (tradeline.test(window.location.href)) {
        user = TRADELINE_STORE_CLIENT_ID
    } else if (tuning.test(window.location.href)) {
        user = TURBOTUNING_AI_CLIENT_ID
    } else if (elem_hellosign_client_id && elem_hellosign_domain) {
        let client_id = elem_hellosign_client_id.value;
        let custom_domain = elem_hellosign_domain.value;
        let reg_exp_custom_domain = new RegExp(custom_domain);

        if (reg_exp_custom_domain.test(window.location.href)){
            user = client_id
        } else {
            user = ''
            console.log('Hellosign client id is not defined')
        }
    }

    // QAN-816: warn and return, never throw.
    //
    // This pack is loaded on EVERY consumer page (packs/consumer.js imports it and
    // layouts/consumer.html.erb tags it again), but only the signing pages use
    // window.client. Throwing here therefore fired on ordinary pages that render no
    // id — every consumer page served from a store's custom domain, where none of the
    // hostname guesses above match. The page that actually needs a client id always
    // renders one now (get_hello_sign_key, on all three signing flows), so an absent id
    // means "this page does not sign", not "this page is broken".
    if (!user || user.trim().length === 0) {
        console.warn('HelloSign: no clientId on this page; the embedded client was not initialised.');
        return;
    }

    window.client = new HelloSign({
        clientId: user
    });

    window.client.on('sign', function(data) {
        const closeBtn = document.querySelector('.x-hellosign-embedded__modal-close-button');
        if (closeBtn) {
            closeBtn.click();
        } else {
            window.client.close();
        }
    });
});